import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchShareClassDto } from '../../types/share-classes.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_SHARE_CLASS], {
    mutationFn: ({
      companyId,
      data,
      shareClassId,
    }: {
      companyId: string;
      data: PatchShareClassDto;
      shareClassId: string;
    }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'share-classes', shareClassId],
        },
        {
          body: data,
        },
      ),
  });
  return { update, isPending };
};
